// VueX
import {
    mapGetters,
} from 'vuex';

// Utils
import {
    formatPrice,
} from '@shared/utils/formatter.js';

const tokenItemMixin = {
    name: 'token-item',
    computed: {
        ...mapGetters([
            'defaultCurrency',
            'getCurrencyShortCodeFormatted',
        ]),

        ...mapGetters('voteTokens', ['tokenPriceByPartnerId']),

        defaultCurrencyShortCodeFormatted() {
            return this.getCurrencyShortCodeFormatted(this.defaultCurrency.id);
        },
    },
    watch: {
        partner: {
            immediate: true,
            handler() {
                const {
                    status,
                    tokenPrice: {
                        rawValue,
                        value,
                        info,
                        altValue,
                        state,
                    },
                } = this.tokenPriceByPartnerId(this.partner, this.defaultCurrency.id);

                this.status = status;
                this.tokenPrice = {
                    rawValue,
                    value,
                    info: info.includes('--') ? info : this.$t(info),
                    altValue,
                    state,
                };

                this.generatePricing();
            },
        },
        market() {
            if (this.partner) {
                this.generatePricing();
            }
        },
    },
    methods: {
        generatePricing() {
            const {
                status,
                tokenPrice: {
                    hasPrice,
                    rawValue,
                    value,
                    info,
                    altValue,
                    state,
                },
            } = this.tokenPriceByPartnerId(this.partner, this.defaultCurrency.id);

            const tickerPrices = this.generateTickerPricing(this.market, value);

            this.status = status;

            this.tokenPrice = {
                hasPrice,
                value: tickerPrices.price,
                rawValue: tickerPrices.rawPrice ?? rawValue,
                info: info.includes('--') ? info : this.$t(info),
                altValue,
                evolutionPercentage: tickerPrices.evolutionPercentage,
                state,
            };

            return this.tokenPrice;
        },
        generateTickerPricing(market, value) {
            // Obtain ticker prices just for marketplace and partner pages
            let evolutionPercentage = '',
                price = '',
                rawPrice = null;

            if (market.ticker) {
                price = formatPrice(market.ticker.lastPrice, this.defaultCurrencyShortCodeFormatted, true);
                rawPrice = market.ticker.lastPrice;

                if (parseFloat(market.ticker.evolutionPercentage) !== 0) {
                    evolutionPercentage = market.ticker.evolutionPercentage + '%';
                }
            } else {
                price = value;
            }

            return {
                evolutionPercentage,
                price,
                rawPrice,
            };
        },
    },
};

export default tokenItemMixin;